<script setup lang="ts">
import Wrapper                    from "@ViewLayouts/Wrapper.vue";
import { onMounted, provide }     from "vue";
import HeaderTop                  from "@ViewPages/Main/Components/Header/HeaderTop.vue";
import type { TypeCommonProps }   from "@ViewPages/Main/Components/commonTypes";
import HeaderBody                 from "@ViewPages/Main/Components/Header/HeaderBody.vue";
import { handleValidateForms }    from "@TsUtils/helpers";
import { handleParsePhoneNumber } from "@TsUtils/parseTelephone";
import Services                   from "@ViewPages/Main/Components/Services/Services.vue";
import DeliverySteps              from "@ViewPages/Main/Components/DeliverySteps/DeliverySteps.vue";
import Container                  from "@ViewCommonComponents/Container.vue";
import About                      from "@ViewPages/Main/Components/About/About.vue";
import Advantages                 from "@ViewPages/Main/Components/Advantages/Advantages.vue";
import Consultation               from "@ViewPages/Main/Components/Consultation/Consultation.vue";
import Review                     from "@ViewPages/Main/Components/Reviews/Reviews.vue";
import Partners                   from "@ViewPages/Main/Components/Partners/Partners.vue";
import Map                        from "@ViewPages/Main/Components/Map/Map.vue";
import Top                        from "@ViewPages/Main/Components/Footer/Top.vue";
import Bottom                     from "@ViewPages/Main/Components/Footer/Bottom.vue";

const props = defineProps<TypeCommonProps>();

provide('header_props', {
    success: props?.success,
    error: props?.error,
    logo_img_tag: props?.logo_img_tag,
    language_menu: props?.language_menu,
    tel: props?.tel,
    instagram_link: props?.instagram_link,
    containers_img_tag: props?.containers_img_tag,
    meta_title: props?.meta_title,
});

provide('delivery_steps_data', {
    delivery_steps_data: props.delivery_steps_data,
    device_type: props.device_type,
});

provide('advantages_data', {
    advantages_data: props.advantages_data,
    device_type: props.device_type,
});

provide('reviews_data', {
    reviews_data: props.reviews_data,
    device_type: props.device_type,
});

provide('partners_data', {
    partners_data: props.partners_data,
    device_type: props.device_type,
});

onMounted(() => {
    handleValidateForms();
    handleParsePhoneNumber();
});
</script>

<template>
    <Wrapper :success :error :title="meta_title" :headerClass="'mb-9 xl:mb-136px'">
        <template #header>
            <Container>
                <HeaderTop></HeaderTop>
                <HeaderBody></HeaderBody>
            </Container>
        </template>

        <template #main>
            <Services :services_data="props.services_data"></Services>
            <DeliverySteps :delivery_steps_data="props.delivery_steps_data"></DeliverySteps>
            <About :about_data></About>
            <Advantages></Advantages>
            <Consultation></Consultation>
            <Review></Review>
            <Partners></Partners>
            <Map></Map>
        </template>

        <template #footer>
            <Top :top_data="footer_data.top_data"></Top>
            <Bottom :bottom_data="footer_data.bottom_data"></Bottom>
        </template>
    </Wrapper>
</template>

<style scoped>

</style>
